import { Translation } from "@/data/lang";
import { links } from "@/data/links";
import { ChartConfigList } from "@/features/analysis/services/chart-config-list";
import { ChartCategory } from "@/features/analysis/types/chart";
import { Lang } from "@/i18n-config";

type NavigationSection = {
  key: ChartCategory;
  title: string;
  subtitle: string;
  subLinks: NavigationLink[];
};

type NavigationLink = {
  name: string;
  pageLink: string;
  disabled: boolean;
};

export const getChartNavigationList = ({
  lang,
  t,
  symbol,
  chartConfigs,
}: {
  lang: Lang;
  t: Translation;
  symbol: string;
  chartConfigs: ChartConfigList;
}): NavigationSection[] => {
  return [
    {
      key: "financial",
      title: t.analysis.financialMetrics.category.financial.title,
      subtitle: t.analysis.financialMetrics.category.financial.subtitle,
      subLinks: chartConfigs.financialReport.financial.map((config) => ({
        name: config.title,
        pageLink: `/${lang}${links.myAnalysisFinancialMetricsChart({
          symbol,
          slug: config.slug,
        })}`,
        disabled: config.disabled,
      })),
    },
    {
      key: "valuation",
      title: t.analysis.financialMetrics.category.valuation.title,
      subtitle: t.analysis.financialMetrics.category.valuation.subtitle,
      subLinks: chartConfigs.financialReport.valuation.map((config) => ({
        name: config.title,
        pageLink: `/${lang}${links.myAnalysisFinancialMetricsChart({
          symbol,
          slug: config.slug,
        })}`,
        disabled: config.disabled,
      })),
    },
    {
      key: "growth",
      title: t.analysis.financialMetrics.category.growth.title,
      subtitle: t.analysis.financialMetrics.category.growth.subtitle,
      subLinks: chartConfigs.financialReport.growth.map((config) => ({
        name: config.title,
        pageLink: `/${lang}${links.myAnalysisFinancialMetricsChart({
          symbol,
          slug: config.slug,
        })}`,
        disabled: config.disabled,
      })),
    },
    {
      key: "profitability",
      title: t.analysis.financialMetrics.category.profitability.title,
      subtitle: t.analysis.financialMetrics.category.profitability.subtitle,
      subLinks: chartConfigs.financialReport.profitability.map((config) => ({
        name: config.title,
        pageLink: `/${lang}${links.myAnalysisFinancialMetricsChart({
          symbol,
          slug: config.slug,
        })}`,
        disabled: config.disabled,
      })),
    },
  ];
};
